import { EXTENSION_ID, MessageTypes } from '@dupe/common/constants'
import { useEffect } from 'react'

const validExtension = ['dupe', 'dupe-safari-ios']

const usePostMessageListener = (
  key: string,
  callback: (messageType: string, data: any) => void,
  messageReceivedCallback?: (event: MessageEvent) => void
) => {
  useEffect(() => {
    const callbackFn = (event: MessageEvent) => {
      const data = event.data || {}
      const messageType = data?.type
      const messageKey = data?.key

      try {
        if (
          !validExtension.includes(data?.extension) ||
          data?.extensionId !== EXTENSION_ID
        ) {
          return
        }

        if (messageType === MessageTypes.MESSAGE_RECEIVED) {
          if (messageKey !== key) {
            return
          }

          if (messageReceivedCallback) {
            messageReceivedCallback(event)
          }

          return
        }

        // Send response to the extension to end retry logic
        window.postMessage(
          {
            key,
            type: MessageTypes.MESSAGE_RECEIVED,
            extension: 'dupe',
            extensionId: EXTENSION_ID,
          },
          '*'
        )

        callback(messageType, data)
      } catch (error) {
        console.error('Error in usePostMessageListener:', error)
      }
    }

    window.addEventListener('message', callbackFn)
    return () => window.removeEventListener('message', callbackFn)
  }, [callback, key, messageReceivedCallback])
}

export default usePostMessageListener
